const $$splitComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/devices/$deviceId.tsx?tsr-split=component');
const $$splitErrorComponentImporter = () => import('/home/runner/work/vision-lab-frontend/vision-lab-frontend/src/routes/_authenticated/_workspace/devices/$deviceId.tsx?tsr-split=errorComponent');
import { lazyRouteComponent } from '@tanstack/react-router';
import { requireCapabilities } from '@/features/authentication/lib/routeGuards';
import { DeviceDetailPendingState } from '@/features/device-management/components/DeviceDetailPendingState';
import { deviceHistorySearchSchema } from '@/features/device-management/lib/deviceManagementSearch';
import { deviceQuery } from '@/features/device-management/services/deviceManagementQueries';
import { browserTimeZone } from '@/shared/lib/dateTime';
import { createFileRoute } from '@tanstack/react-router';
export const Route = createFileRoute('/_authenticated/_workspace/devices/$deviceId')({
  beforeLoad: requireCapabilities(has => has('devices.read')),
  validateSearch: deviceHistorySearchSchema,
  remountDeps: ({
    params
  }) => params.deviceId,
  loader: ({
    context,
    params
  }) => context.queryClient.ensureQueryData(deviceQuery(params.deviceId, browserTimeZone())),
  pendingComponent: DeviceDetailPendingState,
  errorComponent: lazyRouteComponent($$splitErrorComponentImporter, 'errorComponent'),
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});